import type { DeviceOption, DeviceOptions, Platform } from "./device-options.types";

/** Typed locally: the website does not depend on the HSS model package. Mirrors HSS GetReplacementOptionsOutput. */
export interface ReplacementOptionWire {
  id?: string;
  make?: string;
  model?: string;
  specs?: Record<string, string>;
}

export interface GetReplacementOptionsWire {
  options?: ReplacementOptionWire[];
  keyboardLayouts?: string[];
}

/** Keys are Aguacate's raw `specs.os` values, matched exactly as the New Hire IT Card does. */
const PLATFORM_BY_OS: Record<string, Platform> = {
  Mac: "mac",
  Windows: "windows",
};

const SPEC_LINE_KEYS = ["processor", "ram", "storage"];

const buildSpecsLine = (specs?: Record<string, string>): string =>
  SPEC_LINE_KEYS.map((key) => specs?.[key])
    .filter((value): value is string => typeof value === "string" && value.trim().length > 0)
    .map((value) => value.trim())
    .join(", ");

const toDeviceOption = (option: ReplacementOptionWire): DeviceOption | undefined => {
  const { id, make, model, specs } = option;
  if (!id || !make || !model) {
    console.warn("Excluding replacement option missing id, make or model", { id });
    return undefined;
  }
  const platform = specs?.os ? PLATFORM_BY_OS[specs.os] : undefined;
  if (!platform) {
    console.warn("Excluding replacement option with unsupported os", { id, os: specs?.os });
    return undefined;
  }
  return { id, make, model, specsLine: buildSpecsLine(specs), platform };
};

export const mapReplacementOptions = (wire: GetReplacementOptionsWire): DeviceOptions => ({
  options: (wire.options ?? [])
    .map(toDeviceOption)
    .filter((option): option is DeviceOption => option !== undefined),
  keyboardLayouts: wire.keyboardLayouts ?? [],
});
